import { Outlet } from "react-router-dom";

import { useUserRole } from "components/Sidebar/hooks/useUserRole";
import { AccessDenied } from "components/ui/AccessDenied/AccessDenied";

export const ProtectedRoute = ({ roles = [], children }) => {
  const { hasAccess } = useUserRole();

  if (!hasAccess(roles)) {
    return <AccessDenied />;
  }

  return children || <Outlet />;
};
